import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './Button';
export const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navItems = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Why Us',
    href: '#why-deploid'
  }];
  return <motion.header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-black/90 backdrop-blur-xl py-3 border-b border-neon-blue/20 shadow-[0_0_30px_rgba(234,246,255,0.1)]' : 'bg-transparent py-6'}`} initial={{
    opacity: 0,
    y: -20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-94">
      <div className="container mx-auto px-4 md:px-6 flex justify-between items-center relative z-10" data-id="element-95">
        <motion.a href="#" className="text-neon-blue font-heading text-xl md:text-2xl font-light tracking-wider" whileHover={{
        scale: 1.05
      }} data-id="element-96">
          DEPLOID
        </motion.a>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-97">
          {navItems.map((item, index) => <motion.a key={item.name} href={item.href} className="text-neon-blue/80 text-sm hover:text-neon-blue transition-all duration-300 relative group" initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.3,
          delay: index * 0.1
        }} whileHover={{
          y: -2
        }} data-id="element-98">
              {item.name}
              <span className="absolute -bottom-1 left-0 w-0 h-[1px] bg-neon-blue/60 group-hover:w-full transition-all duration-300" data-id="element-99" />
            </motion.a>)}
        </nav>
        {/* Mobile Menu Button */}
        <motion.button className="md:hidden text-neon-blue relative p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} whileTap={{
        scale: 0.95
      }} data-id="element-100">
          <div className="absolute inset-0 bg-neon-blue/10 rounded-sm opacity-0 hover:opacity-100 transition-opacity" data-id="element-101" />
          {isMobileMenuOpen ? <XIcon size={24} className="text-neon-blue relative z-10" data-id="element-102" /> : <MenuIcon size={24} className="text-neon-blue relative z-10" data-id="element-103" />}
        </motion.button>
      </div>
      {/* Mobile Menu */}
      <AnimatePresence data-id="element-104">
        {isMobileMenuOpen && <motion.div className="md:hidden absolute top-full left-0 right-0 bg-black/95 backdrop-blur-xl border-b border-neon-blue/20" initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-105">
            <div className="container mx-auto px-4 py-6 flex flex-col space-y-4" data-id="element-106">
              {navItems.map((item, index) => <motion.a key={item.name} href={item.href} className="text-neon-blue/80 text-sm py-3 hover:text-neon-blue transition-colors border-b border-neon-blue/10" onClick={() => setIsMobileMenuOpen(false)} initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.2,
            delay: index * 0.05
          }} whileHover={{
            x: 5
          }} data-id="element-107">
                  {item.name}
                </motion.a>)}
              <Button primary className="self-start mt-4" data-id="element-108">
                Contact Us
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.header>;
};